import { gql } from '@apollo/client';
import { REPORT, USER, INSTITUTION, INTERVENTION, PROGRAMME, SERVICE_PROVIDER } from '../fragments';

export const UPSERT_REPORT = gql`
  mutation upsertReport($input: UpsertReportInput!) {
    report: upsertReport(input: $input) {
      ...report
      createdBy {
        ...user
      }
      institutions {
        ...institution
      }
      interventions {
        ...intervention
      }
      programmes {
        ...programme
      }
      serviceProvider {
        ...serviceProvider
      }
    }
  }
  ${REPORT}
  ${USER}
  ${INSTITUTION}
  ${INTERVENTION}
  ${PROGRAMME}
  ${SERVICE_PROVIDER}
`;
